export default class Constants {
    // static USERNAME_REGEX = /^[a-zA-Z][a-zA-Z0-9-_]{5,31}$/;
    static USERNAME_REGEX = /^[a-zA-Z][a-zA-Z0-9-_.]{3,31}$/;
    // static EMAIL_REGEX = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    static EMAIL_REGEX = /^[a-zA-Z][a-zA-Z0-9-_.]{3,31}$/;
    static OTP_REGEX = /^[0-9]{2,5}$/;
    // static PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%&]).{8,255}$/;
    static PASSWORD_REGEX = /^[ -~]{3,255}$/;
    static NAME_REGEX = /^[\p{L}\p{N}\p{M}&.\s-]{3,255}$/u;
    static PHONE_NUMBER_REGEX = /^[6-7][1-5][0-9]{6}$/; // starts with 6, second digit in range(1-5), then any number
    static UNSIGNED_DOUBLE_REGEX = /^[0-9.]{0,20}$/;
    static UNSIGNED_INTEGER_REGEX = /^[0-9]{0,100}$/;
    static CURRENCY_CODE_REGEX = /^[A-Z]{3}$/;
    
    static UNAUTHORIZED = "Unauthorized";

    static get LOCALE() { // en-EN ru-RU tk-TM
        try {
            const system = JSON.parse(localStorage.getItem('system'));
            return system?.locale || "tk-TM";
        } catch { return "tk-TM"; }
    }

    static get PHONE_CODE() {
        try {
            const system = JSON.parse(localStorage.getItem('system'));
            return system?.phoneCode || "+993";
        } catch { return "+993"; }
    }
    static get BASE_COUNTRY() {
        try {
            const system = JSON.parse(localStorage.getItem('system'));
            return system?.baseCountry || "TKM";
        } catch { return "TKM"; }
    }

    static get BASE_CURRENCY() {
        try {
            const system = JSON.parse(localStorage.getItem('system'));
            return system?.baseCurrency || "TMT";
        } catch { return "TMT"; }
    }

    static LANGUAGES = [
        { lng: 'tk', code: 'TM' },
        { lng: 'ru', code: 'RU' },
        { lng: 'en', code: 'EN' },
    ];

    static get NAME_LANGUAGE_MAP() { // which of name/name2/name3 holds which language
        try {
            const system = JSON.parse(localStorage.getItem('system'));
            return system?.nameLanguageMap || { name: 'tk', name2: 'ru', name3: 'en' };
        } catch { return { name: 'tk', name2: 'ru', name3: 'en' }; }
    }

    // Role types — see server/helper/constants.js for the authoritative definition.
    static ROOT = 'ROOT';
    static ADMIN = 'ADMIN';
    static STAFF = 'STAFF';
    static CUSTOM = 'CUSTOM';
    static ROLE_TYPES = [this.ROOT, this.ADMIN, this.STAFF, this.CUSTOM];
    static SUPER_ROLE_TYPES = [this.ROOT, this.ADMIN];

    static ROLE_PATH_PREFIX = {
        [this.STAFF]: "/sp",
    };

    static PENSION_CONTRIBUTION = { SOCIAL: '2', PROFESSION: '3', VOLUNTARY: '5' };
     
    // ---------------------- LINKS ------------------------------------
    // Links Staff Panel
    static SP_DASHBOARD_LINKS = [
        '/sp',
        '/sp/',
        '/sp/production-plans',
        '/sp/holidays'
    ];
    static SP_EMPLOYEE_LINKS = [ '/sp/employee' ];
            
    static SP_ATTENDANCE_LINKS = [
        '/sp/attendance/calendar',
    ];

    static SP_OVERTIME_MANAGEMENT_LINKS = [
        '/sp/ot-mng',
        '/sp/ot-mng/apps',
        '/sp/ot-mng/requested-apps',
        '/sp/ot-mng/approvals/apps',
    ];

    static SP_LEAVE_MANAGEMENT_LINKS = [
        '/sp/leave-mng',
        '/sp/leave-mng/leave-apps',
        '/sp/leave-mng/leave-plan-apps',
        '/sp/leave-mng/my-leave-recalls',
        '/sp/leave-mng/leave-recalls',
        '/sp/leave-mng/approvals/leave-apps',
        '/sp/leave-mng/approvals/leave-plan-apps',
        '/sp/leave-mng/approvals/leave-recalls',
    ];

    static SP_PAYROLL_LINKS = [
        '/sp/payroll/salary-payments',
    ];
    
    static SP_PROFILE_LINKS = [ '/sp/profile/general' ];
        
    static SP_PROFILE_PRIVACY_LINKS = [ '/sp/profile/privacy-and-security' ];

    static SP_PROFILE_NOTIFICATION_LINKS = [ '/sp/profile/notifications' ];
   
    static SP_TASK_MANAGEMENT_LINKS = [
        '/sp/task-mng/v-k',
        '/sp/task-mng/v-l',
        '/sp/task-mng/v-g',
        '/sp/task-mng/calendar'
    ];
    
    static SP_TERMS_LINKS = ['/sp/terms-and-conditions' ];

    // Links Main
    static DASHBOARD_LINKS = [
        '/',
        '/production-plans',
        '/holidays'
    ];
 
    static HR_LINKS = [
        '/hr',
        '/hr/employees',
        '/hr/employees/create',
        '/hr/attendances',
        '/hr/employees-bank-accounts',
        '/hr/employees-pension-accounts',
        '/hr/departments',
        '/hr/positions',
        '/hr/staffing-units',
        '/hr/staff-categories',
        '/hr/research-types',
        '/hr/timesheet', '/hr/timesheet-periods',
        '/hr/duty-roster', '/hr/duty-roster-periods',
        '/hr/leave-mng',
        '/hr/ot-mng',
        '/hr/ot-mng/apps',
    ];

    static PAYROLL_LINKS = [
        '/payroll',
        '/payroll/calculation',
        '/payroll/payrolls',
        '/payroll/payrolls/create',
        '/payroll/payrolls/:id',
        '/payroll/payrolls/payslip/:id',
        '/payroll/payrolls/:id/payroll-pensions',
        '/payroll/payrolls/payslip-pension/:id',
    ];

    static PRODUCT_LINKS = [
        '/product',
        '/product/trade-parties',
        '/product/warehouses',
        '/product/purchases',
        '/product/purchases/create',
        '/product/sales',
        '/product/sales/create',
        '/product/products',
        '/product/products/create'
    ];

    static FINANCE_LINKS = [
        '/finance',
        '/finance/payment-orders',
        '/finance/payment-orders/create',
        '/finance/payment-orders/:id',
    ];

    static REPORTS_LINKS = [
        '/reports',
        '/reports/salary',
        '/reports/salary/payroll-statement-by-department',
        '/reports/salary/payroll-statement-by-category',
        '/reports/salary/payroll-statement-group-by-department',
        '/reports/salary/payroll-statement-group-by-category',
        '/reports/salary/bank-statement',
        '/reports/salary/appendix-3',
        '/reports/salary/pension-contribution',
        '/reports/salary/payment-orders',
        '/reports/hr',
        '/reports/hr/payment-orders',
        '/reports/finance',
        '/reports/finance/payment-orders'
    ];

    static TASK_MANAGEMENT_LINKS = [
        '/task-mng/v-k',
        '/task-mng/v-l',
        '/task-mng/v-g',
        '/task-mng/calendar'
    ];

    static DOCUMENT_MANAGEMENT_LINKS = [
        '/doc-mng',
        '/doc-mng/chancellery/incoming-letters',
        '/doc-mng/chancellery/outgoing-letters',
        '/doc-mng/chancellery/internal-letters',
        '/doc-mng/chancellery/draft',
        '/doc-mng/chancellery/archive',
        '/doc-mng/chancellery/trash',
    ];

    static INSIGHTS_LINKS = [
        '/insights',
        '/insights/hr',
        '/insights/salary'
    ];

    static COMPANY_LINKS = [
        '/company',
        '/company/contracts',
        '/company/parties'
    ];

    static SETTINGS_GENERAL_LINKS = [
        '/settings/general',
        '/settings/general/banks',
        '/settings/general/currencies',
        '/settings/general/countries',
        '/settings/general/industries',
        '/settings/general/provinces',
        '/settings/general/contract-types',
        '/settings/general/document-types',
        '/settings/general/doc-letter-types',
        '/settings/general/party-types',
        '/settings/general/passport-issuing-authorities',
        '/settings/general/payment-order-templates',
    ];

    static SETTINGS_HR_LINKS = [
        '/settings/hr',
        '/settings/hr/production-plans',
        '/settings/hr/staff-categories',
        '/settings/hr/departments',
        '/settings/hr/positions',
        '/settings/hr/staffing-units',
        '/settings/hr/research-types',
        '/settings/hr/harmfulness-levels',
        '/settings/hr/leave-types',
        '/settings/hr/attendance-types',
        '/settings/hr/salary-grades',
        '/settings/hr/languages',
        '/settings/hr/higher-educations',
        '/settings/hr/study-fields',
        '/settings/hr/study-qualifications',
        '/settings/hr/skill-grades',
        '/settings/hr/employment-statuses',
        '/settings/hr/work-locations',
        '/settings/hr/working-regimes',
    ];
    
    static SETTINGS_SALARY_LINKS = [
        '/settings/salary',
        '/settings/salary/deduction-types',
        '/settings/salary/additional-payments',
        '/settings/salary/formula-configs',
    ];

    static SETTINGS_PRODUCT_LINKS = [
        '/settings/product',
        '/settings/product/warehouses',
        '/settings/product/classifications',
        '/settings/product/categories',
        '/settings/product/brands',
        '/settings/product/manufacturers',
        '/settings/product/unit-measurements',
        '/settings/product/properties',
        '/settings/product/variations',
        '/settings/product/buildings',
    ];

    static SETTINGS_BALANCE_LINKS = [
        '/settings/balance',
        '/settings/balance/chart-of-accounts',
        '/settings/balance/account-articles',
        '/settings/balance/memorial-orders',
    ];

    static SETTINGS_ADMINISTRATION_LINKS = [
        '/settings/administration',
        '/settings/administration/users',
        '/settings/administration/logs',
        '/settings/administration/roles',
        '/settings/administration/backup',
        '/settings/administration/system-settings',
        '/settings/administration/terms',
        '/settings/administration/api-clients',
    ];

    static SETTINGS_PROFILE_LINKS = [ '/profile/general' ];
    
    static SETTINGS_PROFILE_PRIVACY_LINKS = [ '/profile/privacy-and-security' ];

    static SETTINGS_PROFILE_NOTIFICATION_LINKS = [ '/profile/notifications' ];
    
    static MODULES = [
        'DASHBOARD', 'HR', 'EMPLOYEES', 'TIMESHEET_MANAGEMENT', 'LEAVE_MANAGEMENT','OVERTIME_MANAGEMENT', 'PAYROLL',
        'PRODUCT', 'WAREHOUSE', 'PURCHASE', 'SALE', 'FINANCE', 'INSIGHTS', 'COMPANY', 'TASK_MANAGEMENT', 'DOCUMENT_MANAGEMENT',
        'SETTINGS', 'SETTINGS_ADMIN', 'STAFF_PANEL'
    ];

    static MODELS = [
        'USER', 'LOGIN', 'PASSWORD_CHANGE', 'PASSWORD_RESET', 'ROLE', 'SETTINGS', 'BACKUP', 'LOG', 'FORMULA',
        'TERMS', 'TERMS_VERSION', 'TASK', 'BLANK_TEMPLATE',
        
        'BANK', 'BANK_ACCOUNT', 'CURRENCY', 'COUNTRY', 'DISTRICT', 'PROVINCE',
        
        'EMPLOYEE', 'EMPLOYMENT_STATUS', 'PASSPORT', 'PASSPORT_ISSUING_AUTHORITY', 'EMPLOYEE_BANK_ACCOUNT', 'EMPLOYEE_PENSION_ACCOUNT',
        'ALIMONY_PAYER', 'FAMILY_MEMBER', 'EMPLOYEE_EDUCATION', 'HIGHER_EDUCATION', 'EMPLOYEE_DOCUMENT',
        'LANGUAGE', 'EMPLOYEE_LANGUAGE', 'EMPLOYEE_WORK_SCHEDULE', 'MILITARY_SERVICE',
        'WORK_EXPERIENCE', 'WORK_HISTORY', 'WORK_HISTORY_DEDUCTION', 'WORK_LOCATION', 'WORKING_REGIME',
        'SALARY_GRADE', 'STAFF_CATEGORY', 'STAFF_GROUP', 'DEPARTMENT', 'DEPARTMENT_ROLE', 'POSITION', 'RESEARCH_TYPE', 'STAFFING_UNIT',
        'STATE_CLASSIFICATION', 'COST_CENTRE', 'HARMFULNESS_LEVEL', 'SKILL_GRADE', 'DEDUCTION_TYPE', 'STUDY_FIELD', 'STUDY_QUALIFICATION',
        'LEAVE_PLAN_PERIOD', 'LEAVE_APP', 'LEAVE_PLAN_APP', 'LEAVE_TYPE', 'LEAVE_TYPE_OVERRIDE', 'LEAVE_APPROVAL_ROLE', 'LEAVE_RECALL', 'OVERTIME_APP', 'OVERTIME_TYPE', 'OVERTIME_APPROVAL_ROLE', 'EMPLOYEE_ORDER', 'ATTENDANCE_TYPE',
        'PRODUCTION_PLAN', 'TIMESHEET_PERIOD', 'TIMESHEET', 'TIMESHEET_REVISION', 'DUTY_ROSTER_PERIOD', 'DUTY_ROSTER', 'CHECK_IN_OUT',

        'PAYROLL', 'PAYROLL_ENTRY', 'ADDITIONAL_PAYMENT',
        
        'PARTY', 'PARTY_TYPE', 'PARTY_BANK_ACCOUNT', 'INDUSTRY', 'CONTRACT', 'CONTRACT_TYPE',
        'PAYMENT_ORDER', 'PAYMENT_PURPOSE_TEMPLATE',
        
        'ITEM', 'UNIT_MEASURE', 'MANUFACTURER', 'BRAND', 'UNIT_MEASURE_GROUP', 'VARIATION_OPTION', 'VARIATION_TYPE',
        'PRODUCT_CLASSIFICATION', 'PRODUCT_CATEGORY', 'DEVICE_GROUP', 'PRODUCT_PROPERTY', 'ASSET',
        'WAREHOUSE', 'BUILDING', 'INVENTORY_SESSION', 'PURCHASE', 'STOCK_BATCH', 'STOCK_REQUEST', 
        
        'DOC_LETTER', 'LETTER_TYPE', 'DOCUMENT', 'DOCUMENT_TYPE',
        
        'ACCOUNT_ARTICLE', 'ACCOUNT_BALANCE', 'CHART_OF_ACCOUNT', 'JOURNAL_ENTRY', 'MEMORIAL_ORDER',
        'API_CLIENT',
    ];

    static ACTION_TYPE = ['WRITE', 'UPDATE', 'DELETE', 'READ'];
    static WORK_UNITS = [1, 0.75, 0.5, 0.3, 0.25, 0.1];
    static MONTHS = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
    static FUNDING_TYPES = ['BUDGET', 'SELF_FINANCING'];
    static PAYROLL_STATUSES = ['DRAFT', 'CALCULATED', 'APPROVED', 'PAID', 'ARCHIVED', 'CANCELLED'];
    static PAYMENT_ORDER_STATUSES = ['DRAFT', 'PAID'];
    static EMPLOYEE_STATUSES = ['OK', 'ANNUAL_LEAVE', 'UNPAID_LEAVE', 'ADDITIONAL_LEAVE', 'SICK_LEAVE', 'MATERNITY_LEAVE', 'PARENTAL_LEAVE', 'BUSINESS_TRIP', 'PROBATION'];
    static IN_OUT = ['IN', 'OUT'];
    static EDUCATION_DEGREE = ['VOCATIONAL_BASIC', 'VOCATIONAL_MIDDLE', 'VOCATIONAL', 'BACHELOR', 'MASTER', 'PhD'];
    static EDUCATION_TYPE = ['DAYTIME', 'EVENING', 'CORRESPONDENCE'];
    static EDUCATION_STATUS = ['COMPLETED', 'ONGOING', 'DROPPED_OUT'];
    static EDUCATION_LEVEL = ['NONE', 'SECONDARY', 'VOCATIONAL_BASIC', 'VOCATIONAL_MIDDLE', 'VOCATIONAL', 'HIGH'];
    static MARITAL_STATUS = ['SINGLE', 'MARRIED', 'DIVORCED', 'WIDOWED'];
    static FAMILY_MEMBER_DEGREE = ['HUSBAND, WIFE', 'SON', 'DAUGHTER'];
    static GENDER = ['M', 'F'];
    static TASK_PRIORITY = ['LOW', 'MEDIUM', 'HIGH', 'CRITICAL'];
    static TASK_SCOPE_TYPES = ['SYSTEM', 'SPACE', 'LIST', 'TASK'];
    static TASK_STATUSES = ['NOT_STARTED', 'ACTIVE', 'DONE', 'CLOSED'];
    static RECALCULATION_TYPES = ['SURCHARGE', 'RETENTION'];
    static HOLIDAY_TYPES = ['NATIONAL', 'RELIGIOUS', 'COMPANY_SPECIFIC', 'OTHER'];
    static EMPLOYEE_LOCALITY_TYPE = ['LOCAL', 'EXPATRIATE'];
    static TIMESHEET_PERIOD_STATUSES = ['OPEN', 'CLOSED'];
    static TIMESHEET_STATUSES = ['DRAFT', 'SUBMITTED', 'VERIFIED', 'APPROVED', 'LOCKED'];
    static DUTY_ROSTER_PERIOD_STATUSES = ['OPEN', 'CLOSED'];
    static DUTY_ROSTER_STATUSES = ['DRAFT', 'SUBMITTED', 'VERIFIED', 'APPROVED', 'LOCKED'];
    static LEAVE_CATEGORIES = ['PAID', 'UNPAID', 'SPECIAL', 'OTHER'];
    static LEAVE_GROUPS = ['ANNUAL', 'SICK', 'OTHER'];
    static LEAVE_APP_STATUSES = ['DRAFT', 'APPLIED', 'PROCESSING', 'APPROVED', 'REJECTED', 'CANCELLED'];
    static TREATMENT_TYPES = ['OUTPATIENT', 'INPATIENT'];
    static SICK_LEAVE_FORS = ['SELF', 'DEPENDENT_CARE'];
    static LEAVE_RECALL_STATUSES = ['DRAFT', 'APPLIED', 'PROCESSING', 'APPROVED', 'REJECTED'];
    static LEAVE_RECALL_ARTICLES = ['105', '109'];
    static LEAVE_MNG_TYPES = ['LEAVE_APP', 'LEAVE_PLAN', 'LEAVE_RECALL'];
    static SHIFT_TYPES = ['DAY_SHIFT', 'NIGHT_SHIFT', 'ROTATION_ON', 'ROTATION_OFF', 'REST_DAY', 'SPECIAL_SHIFT'];
    static WORK_TYPES = ['OFFICE', 'REMOTE'];
    static DEVICE_SOURCE_TYPE = ['WEB', 'MOBILE'];
    static ATTENDANCE_STATUSES = ['PRESENT', 'ABSENT', 'LEAVE', 'SICK', 'REMOTE', 'HALF_DAY', 'BUSINESS_TRIP'];
    static OVERTIME_APP_STATUSES = ['DRAFT', 'APPLIED', 'PROCESSING', 'APPROVED', 'REJECTED', 'CANCELLED'];
    static OVERTIME_APP_ASSIGNEE_STATUSES = ['PENDING', 'APPROVED', 'REJECTED'];
    static OVERTIME_COMPENSATION_TYPES = ['MONETARY', 'COMPENSATORY'];
    // Paid overtime is worth double time (Labor Code art. 120/121); time off in lieu is accrued
    // at single time, the premium being the compensatory rest day itself.
    static OVERTIME_COMPENSATION_MULTIPLIERS = { MONETARY: 2, COMPENSATORY: 1 };
    static PARTY_TYPES = ['LEGAL', 'PHYSICAL'];
    static OVERTIME_GROUPS = ['OVERTIME', 'DAY_OFF'];
    static WORKING_REGIME_GROUPS = ['NORMAL', 'HOURLY'];
    static DEPARTMENT_ROLE_TYPES = ['DEPUTY_DIRECTOR', 'HEAD', 'DEPUTY_HEAD', 'SUPERVISOR'];
    static TERMS_APPLIES_TO = ['GLOBAL', 'DEPARTMENT', 'POSITION', 'STAFF'];
    static OBLIGATION_TYPE = ['RECEIVABLE', 'PAYABLE'];
    static CONTRACT_STATUSES = ['DRAFT', 'IN_REVIEW', 'APPROVED', 'OPEN', 'CLOSE', 'ARCHIVED'];
    static CONTRACT_PARTY_TYPES = ['GUARANTOR', 'AGENT', 'SUBCONTRACTOR', 'PARTNER'];
    static DATA_TYPES = ['NUMBER', 'TEXT', 'BOOLEAN', 'DATE'];
    static PURCHASE_STATUSES = ['DRAFT', 'CONFIRMED', 'SHIPPED', 'RECEIVED', 'COMPLETED', 'CANCELLED'];
    static PAYMENT_STATUSES = ['PENDING', 'PARTIAL', 'PAID'];
    static COSTING_METHOD = ['FIFO', 'LIFO', 'FEFO'];
    static ITEM_TYPES = ['PRODUCT', 'SERVICE'];
    static WAREHOUSE_TYPES = ['WAREHOUSE', 'DEPARTMENT'];
    static STOCK_REQUEST_STATUSES = ['PENDING', 'CONFIRMED', 'RECEIVED', 'COMPLETED', 'CANCELLED', 'REJECTED'];
    static INVENTORY_SESSION_TYPES = ['STOCK', 'ASSET'];
    static INVENTORY_SESSION_STATUSES = ['DRAFT', 'IN_PROGRESS', 'COMPLETED', 'CANCELLED'];
    static ASSET_CONDITION = ['OK', 'DAMAGED', 'LOST'];
    static HTTP_METHODS = ['GET', 'POST', 'PUT', 'DELETE'];
    static DOC_LETTER_TYPES = ['INCOMING', 'OUTGOING', 'INTERNAL'];
    static DOC_LETTER_STATUSES = ['DRAFT', 'SENT', 'ARCHIVED', 'DELETED', 'REJECTED'];
    static DOC_LETTER_ASSIGNEE_STATUSES = ['PENDING', 'APPROVED', 'REJECTED'];
    static DOC_LETTER_ASSIGNMENT_MODE = ['SEQUENTIAL', 'PARALLEL'];
    static CHART_ACCOUNT_TYPES = ['ACTIVE', 'PASSIVE', 'HYBRID'];
    static ACCOUNT_ARTICLE_TYPES = ['ACTIVE', 'PASSIVE'];
    static LANGUAGE_LEVEL = ['A1', 'A2', 'B1', 'B2', 'C1', 'C2', 'NATIVE'];
    static PASSPORT_TYPE = ['P', 'D'];
    static SKILL_GROUPS = ['BUSINESS', 'TECHNICAL'];
    static SKILL_GRADE_CATEGORIES = ['EXECUTIVE', 'NON_EXECUTIVE', 'SECRETARY'];
    static MILITARY_FITNESS_STATUSES = ['FIT', 'UNFIT'];
    static LEAVE_PLAN_PERIOD_STATUSES = ['OPEN', 'CLOSED'];
    static LEAVE_APP_ASSIGNEE_STATUSES = ['PENDING', 'APPROVED', 'REJECTED', 'ACKNOWLEDGED'];
    
    static LEAVE_PLAN_APP_MAX_RANGES = 10;

    static SUPPORTED_IMAGE_FORMATS = ["jpg", "jpeg", "png"];
    static TASK_STATUS_COLORS = [
        '#9e9e9e', '#6B7280', '#514cd2', '#8B5CF6', '#215df3', '#2196f3', '#4caf50', '#14B8A6',
        '#a0c226', '#dac314', '#F59E0B', '#ff7614', '#EF4444', '#EC4899', '#a07552', '#35373c',
    ];

    static API_RESOURCES = {
        employees: ['id', 'firstName', 'lastName', 'middleName', 'gender', 'dob', 'pob', 'passport', 'nationalityId', 'educationLevel', 'maritalStatus', 'status', 'bloodGroup', 'retirementAge', 'hireDate', 'terminationDate', 'phone', 'email', 'active' ],
        assets: ['id', 'itemId', 'inventoryNo', 'departmentId', 'responsibleStaffId', 'roomId', 'serialNo', 'active', 'registrationDate', 'description'],
    };
}